import type { TradingLanguage } from "@tradingApp/components/Trading/Languages/types";
import type { HistoricalOrder } from "hyperliquid";

export const TRADING_TABS_CHILDREN: Record<string, string[]> = {
  positions: [],
  "open-orders": [],
  "history/fills": ["/orders", "/fills", "/funding"],
};

export const TRADING_ASSET_DEFAULT = "BTC";

export const TRADING_NETWORK_DEFAULT = "ARB";

export const TRADING_FIAT = "USD";

export const TRADING_WITHDRAW_ASSET = "USDC";

export const TRADING_FIAT_DECIMALS = 2;

export const TRADING_WITHDRAWAL_FEE = 1;

export const TRADING_LEVERAGE_MIN_DEFAULT = 1;

export const TRADING_LEVERAGE_MAX_DEFAULT = 0;

export const TRADING_VALUE_NOT_AVAILABLE = "N/A";

export const TRADING_ASSET_SIZE_DECIMALS_DEFAULT = 0;

export const TRADING_ORDER_MIN_VALUE = 10;

export const TRADING_HISTORY_ORDER_EXCLUDE_STATUSES: HistoricalOrder["status"][] =
  ["open"];

export const TRADING_META_REFRESH_INTERVAL = 1_000 * 30;

export const TRADING_LANGUAGES: TradingLanguage[] = [
  {
    flagUrl: "/images/icons/en.png",
    locale: "en",
    name: "English",
  },
  {
    flagUrl: "/images/icons/ru.png",
    locale: "ru",
    name: "Русский",
  },
];

export const TRADING_HYPER_TO_DROPSTAB_ASSETS_MAP: Record<string, string> = {
  "2Z": "double-zero-crypto-coin",
  "0G": "0g",
  AAVE: "dogwifcoin",
  ACE: "fusionist",
  ADA: "cardano",
  AI16Z: "ai16z",
  AIXBT: "aixbt-by-virtuals",
  ALGO: "algorand",
  ALT: "altlayer",
  ANIME: "anime-coin",
  APE: "apecoin",
  APEX: "apex-token-2",
  APT: "aptos",
  AR: "arweave",
  ARB: "arbitrum",
  ARK: "ark",
  ASTER: "aster",
  ATOM: "cosmos",
  AVAX: "avalanche",
  AVNT: "avantis",
  BABY: "babylon",
  BANANA: "banana-gun",
  BCH: "bitcoin-cash",
  BERA: "berachain",
  BIGTIME: "big-time",
  BIO: "bio-protocol",
  BLAST: "blast-l2",
  BLUR: "blur",
  BNB: "binancecoin",
  BOME: "book-of-meme",
  BRETT: "based-brett",
  BSV: "bitcoin-cash-sv",
  BTC: "bitcoin",
  CAKE: "pancakeswap-token",
  CELO: "celo",
  CFX: "conflux-token",
  CHILLGUY: "chill-guy-coin",
  COMP: "compound",
  CRV: "curve-dao-token",
  DOGE: "dogecoin",
  DOOD: "doodles",
  DOT: "polkadot",
  DYDX: "dydx",
  DYM: "dymension",
  EIGEN: "eigenlayer",
  ENA: "ethena-labs",
  ENS: "ethereum-name-service",
  ETC: "ethereum-classic",
  ETH: "ethereum",
  ETHFI: "ether-fi",
  FARTCOIN: "fartcoin",
  FET: "artificial-superintelligence-alliance",
  FIL: "filecoin",
  FTT: "ftx-token",
  FXS: "frax-share",
  GALA: "gala",
  GAS: "gas",
  GMT: "stepn",
  GMX: "gmx",
  GOAT: "goatseus-maximus",
  GRASS: "grass",
  GRIFFAIN: "griffain-solana-crypto",
  HBAR: "hedera-hashgraph",
  HEMI: "hemi-network",
  HMSTR: "hamster-kombat",
  HYPE: "hyperliquid",
  HYPER: "hyper-coin",
  IMX: "immutable-x",
  INIT: "initia",
  INJ: "injective-protocol",
  IO: "io-net",
  IOTA: "iota",
  IP: "story",
  JTO: "jito-network",
  JUP: "jupiter-station",
  KAITO: "kaito",
  KAS: "kaspa",
  kBONK: "bonk",
  kDOGS: "dogs-community",
  kFLOKI: "floki-inu",
  kLUNC: "terra-luna",
  kNEIRO: "neiro-3",
  kPEPE: "pepe",
  kSHIB: "shiba-inu",
  LAUNCHCOIN: "omni-network",
  LAYER: "solayer",
  LDO: "lido-dao",
  LINEA: "linea",
  LINK: "chainlink",
  LTC: "litecoin",
  MANTA: "manta-network",
  MAV: "maverick-protocol",
  MAVIA: "heroes-of-mavia",
  ME: "magic-eden",
  MELANIA: "melania-trump",
  MEME: "meme-coin",
  MERL: "merlin-chain",
  MEW: "cat-in-a-dogs-world",
  MINA: "mina-protocol",
  MKR: "maker",
  MNT: "mantle",
  MOODENG: "moo-deng",
  MORPHO: "morpho",
  MOVE: "movement",
  NEAR: "near",
  NEIROETH: "neiro-on-eth",
  NEO: "neo",
  NIL: "nillion",
  NOT: "notcoin",
  NXPC: "nexpace",
  OGN: "origin-protocol",
  OM: "mantra-dao",
  OMNI: "launch-coin-on-believe",
  ONDO: "ondo-finance",
  OP: "optimism",
  ORDI: "ordinals",
  PAXG: "pax-gold",
  PENDLE: "pendle",
  PENGU: "pudgy-penguins",
  PEOPLE: "constitutiondao",
  PNUT: "peanut-the-squirrel",
  POL: "polygon-ecosystem-token",
  POLYX: "polymesh",
  POPCAT: "popcat",
  PROMPT: "wayfinder",
  PROVE: "succinct",
  PUMP: "pump-fun",
  PURR: "purr-2",
  PYTH: "pyth-network",
  RENDER: "render-token",
  REQ: "request-network",
  RESOLV: "resolv-labs",
  REZ: "renzo-protocol",
  RSR: "reserve-rights-token",
  RUNE: "thorchain",
  S: "sonic-labs",
  SAGA: "saga-2",
  SAND: "the-sandbox",
  SCR: "scroll",
  SEI: "sei-network",
  SKY: "sky-money",
  SNX: "synthetix",
  SOL: "solana",
  SOPH: "sophon",
  SPX: "spx6900",
  STBL: "stbl",
  STG: "stargate-finance",
  STRK: "starknet",
  STX: "stacks",
  SUI: "sui",
  SUPER: "superfarm",
  SUSHI: "sushi",
  SYRUP: "syrup",
  TAO: "bittensor",
  TIA: "celestia",
  TNSR: "tensor",
  TON: "the-open-network",
  TRB: "tellor",
  TRUMP: "official-trump",
  TRX: "tron",
  TST: "test-token",
  TURBO: "turbo",
  UMA: "uma",
  UNI: "uniswap",
  USTC: "terrausd",
  USUAL: "usual",
  VINE: "vine-coin",
  VIRTUAL: "virtual-protocol",
  VVV: "venice",
  W: "wormhole",
  WCT: "walletconnect",
  WIF: "aave",
  WLD: "worldcoin",
  WLFI: "world-liberty-financial",
  XAI: "xai-games",
  XLM: "stellar",
  XPL: "plasma",
  XRP: "ripple",
  YGG: "yield-guild-games",
  YZY: "yzy",
  ZEC: "zcash",
  ZEN: "horizen",
  ZEREBRO: "zerebro",
  ZETA: "zetachain",
  ZK: "zksync",
  ZORA: "zora-crypto",
  ZRO: "layerzero",
} as const;

export const TRADING_ASSET_SHARE_URL =
  "https://t.me/inferno_dev_bot/?startapp=tradeAsset_{asset}";
